<template>
  <div>
    <div class="d-flex align-items-center">
      <div class="side-frame"></div>
      <div>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.shipmentStatus === 'Y'
              ? 'success'
              : formData.shipmentStatus === 'R' ||
                formData.shipmentStatus === 'S'
              ? 'warning'
              : formData.shipmentStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_shipmentStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="baseForm"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      :show-message="showMessage"
      size="mini"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_shipmentNo') || '发运单编号'"
            prop="shipmentNo"
          >
            <el-input
              v-model.trim="formData.shipmentNo"
              clearable
              :placeholder="
                $l('INDEX.form_Please_shipmentNo') || '请输入发运单编号'
              "
              disabled
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item
            :label="$l('INDEX.form_label_showBookContractNo') || '外运编号'"
            prop="showBookContractNo"
          >
            <el-input v-model.trim="formData.showBookContractNo" readonly>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.table_label_custName') || '客户'"
            prop="custCode"
          >
            <el-input
              clearable
              v-model="formData.custName"
              size="mini"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.table_label_endcustomer_name') || '终端客户'"
            prop="endCustCode"
          >
            <el-input
              clearable
              v-model="formData.endCustName"
              size="mini"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderScmCode') || '名义工厂'"
            prop="orderScmCode"
          >
            <dict-select
              v-model="formData.orderScmCode"
              url="/master/common/dict/scmPartners"
              :placeholder="
                $l('INDEX.form_placeholder_orderScmCode') || '请选择名义工厂'
              "
              size="mini"
              clearable
              filterable
              disabled
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_bookingStaff') || '制单人'"
            prop="bookingStaffCode"
          >
            <dict-select
              url="/master/common/dict/baseUserSelect"
              v-model="formData.bookingStaffCode"
              :selectedLabel.sync="formData.bookingStaffName"
              :placeholder="
                $l('INDEX.form_Please_bookingStaff') || '请选择制单人'
              "
              clearable
              filterable
              size="mini"
              :disabled="formData.shipmentStatus !== 'B'"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex align-items-center">
      <div class="side-frame-danger"></div>
      <div>
        <span style="font-size: 15px; color: #606266">
          {{ $l('INDEX.group_goods_info') || '货物信息' }}
        </span>
      </div>
    </div>
    <el-form
      ref="goodsForm"
      :model="formData"
      :rules="rules"
      :show-message="showMessage"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_totalGoodsQty') || '产品总数量'">
            <el-input v-model="formData.totalGoodsQty" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_totalBoxQty') || '总箱数'">
            <el-input v-model="formData.totalBoxQty" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_totalGrossWeight') || '总毛重(kg)'"
          >
            <el-input v-model="formData.totalGrossWeight" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_totalNetWeight') || '总净重(kg)'"
          >
            <el-input v-model="formData.totalNetWeight" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_totalBoxVolume') || '总体积'">
            <el-input v-model="formData.totalBoxVolume" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_totalBookingVolume') || '订舱总体积(m³)'"
          >
            <el-input v-model="formData.totalBookingVolume" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              `${$l('INDEX.form_totalPriceAmount') || '工厂金额'}${
                formData.v_currencyUnit
                  ? '(' + formData.v_currencyUnit + ')'
                  : ''
              }`
            "
          >
            <el-input v-model="formData.totalPriceAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              `${$l('INDEX.form_shipmentSalePrice') || 'ABS金额'}${
                formData.v_salesCurrencyUnit
                  ? '(' + formData.v_salesCurrencyUnit + ')'
                  : ''
              }`
            "
          >
            <el-input v-model="formData.totalSalePriceAmount" readonly>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex mt-2">
      <div class="side-frame-warning"></div>
      <div style="line-height: 34px">
        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName ? formData.createByName : '--' }} at
          {{ formData.createTime ? formData.createTime : '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Submit：{{ formData.submitByName ? formData.submitByName : '--' }} at
          {{ formData.submitTime ? formData.submitTime : '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Review：{{ formData.reviewByName ? formData.reviewByName : '--' }} at
          {{ formData.reviewTime ? formData.reviewTime : '--' }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: {},
  mixins: [EditLoading],
  props: {
    shipmentCode: { type: String, default: '' },
    shipmentStatus: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {},
      showMessage: false,
      rules: {
        shipmentNo: [
          {
            required: true,
            message:
              this.$l('INDEX.form_Please_shipmentNo') || '请输入发运单编号',
            trigger: 'blur',
          },
        ],
        bookingStaffCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_Please_bookingStaff') || '请选择制单人',
            trigger: 'change',
          },
        ],
        custCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_a_customer') ||
              '请选择客户',
            trigger: 'change',
          },
        ],
        orderScmCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_orderScmCode') ||
              '请选择名义工厂',
            trigger: 'change',
          },
        ],
        contractNo: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_contractNo') || '请输入合同号',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.shipmentCode) return
      this.showMessage = false
      this.$api
        .shipmentInfoDetailApi({
          shipmentCode: this.shipmentCode,
        })
        .then((res) => {
          this.formData = res.body

          const { isSingleNo, shipmentStatus } = this.formData
          this.$emit('update:shipmentStatus', shipmentStatus)
          this.formData.isSingleNo = isSingleNo === 'Y'
          setTimeout(() => {
            this.clearValidate()
            setTimeout(() => (this.showMessage = true), 10)
          }, 0)
        })
        .catch(() => {
          setTimeout(() => {
            this.clearValidate()
            setTimeout(() => (this.showMessage = true), 10)
          }, 0)
        })
    },
    async save() {
      const result = await validate.formValidate([
        this.$refs.baseForm,
        this.$refs.goodsForm,
      ])
      if (!result) return

      const { isSingleNo } = this.formData
      this.formData.isSingleNo = isSingleNo ? 'Y' : 'N'

      this.loadingOpen()
      this.$api
        .shipmentInfoSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.loadData()
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    clearValidate() {
      this.$refs.baseForm.clearValidate()
      this.$refs.goodsForm.clearValidate()
    },
  },
}
</script>
<style lang="scss" scoped>
.form-text {
  font-size: 12px;
  padding: 0px;
  margin: 0px;
}

.side-frame,
.side-frame-success,
.side-frame-danger,
.side-frame-warning {
  padding: 1px 5px;
  height: 20px;
  margin: 8px 0;
}

::v-deep .el-radio {
  margin-right: 0;
}
</style>
